import getCombatantIndexById from "./getCombatantIndexById";
import setPendingCA from "./setPendingCA";
import setBlankCA from "./setBlankCA";
import getMarker from "./getMarker";
import store from "../store/index";
//------------------------
// shift pending cas left
//------------------------
export default function shiftPendingCAsLeft(parm, action_number) {
  // console.log("------------------------");
  // console.log("IN shiftPendingCAsLeft");
  // console.log("------------------------");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCA = this_store.config.max_ca;
  //------------------
  // get combatant idx
  //------------------
  let i = getCombatantIndexById(parm.id);
  //--------------------------------
  // def return delete marker array
  //--------------------------------
  let delete_marker_array = [];
  //-------------------
  // get slot to right
  //-------------------
  let from_slot = Number(action_number) + 1;
  //--------------
  // get used cnt
  //--------------
  let slots_used = combatants[i].actual_action_count;
  let combatant_ca = combatants[i].ca;
  let remaining_pending = combatant_ca - slots_used;
  let to_slot = from_slot + remaining_pending - 1;

  if (to_slot > maxCA) {
    to_slot = maxCA;
  }

  // console.log("slots_used = " + slots_used);
  // console.log("new_action name = " + cur_obj.name);
  // console.log("new_action actual = " + cur_obj.actual);
  // console.log("combatant_ca = " + combatant_ca);
  // console.log("remaining_pending = " + remaining_pending);
  // console.log("action_number = " + action_number);
  // console.log("from_slot = " + from_slot);
  // console.log("to_slot = " + to_slot);
  // console.log("------------------------");
  // console.log("going into loop...")
  // console.log("------------------------");
  //----------------------------------------------------------------
  // loop from slot next to where action changed -> possible max ca
  //----------------------------------------------------------------
  for (let k = from_slot; k <= maxCA; k++) {
    let ca_type = "ca_type" + k;
    let ca_name = "ca_name" + k;
    let ca_slug = "ca_slug" + k;

    // console.log(
    //   "k = " +
    //     k +
    //     " type = " +
    //     combatants[i][ca_type] +
    //     " name = " +
    //     combatants[i][ca_name]
    // );
    //---------------
    // set slot parm
    //---------------
    let slot_parm = {
      id: parm.id,
      ca_num: k,
    };
    //----------
    // set slot
    //----------
    if (k <= to_slot) {
      // console.log("ROUTE 1 - k = " + k + " <= " + to_slot);
      //---------------------------------------
      // leave marker if would be pending slot
      //---------------------------------------
      if (combatants[i][ca_type] != "marker") {
        // console.log("setting pending at = " + k);
        setPendingCA(slot_parm);
      }
      //---------------
      // set blank slot
      //----------------
    } else {
      // console.log("ROUTE 2 - k = " + k + " > " + to_slot);
      //---------------------------------
      // delete marker if slot now blank
      //---------------------------------
      if (combatants[i][ca_type] == "marker") {
        //------------
        // get marker
        //------------
        let delete_marker = getMarker(combatants[i][ca_name]);
        //-----------------
        // set delete parm
        //-----------------
        let delete_parm = {
          id: combatants[i].id,
          slug: combatants[i][ca_slug],
          slot: "Marker",
          num: k,
          actual: delete_marker.actual,
          marker_name: delete_marker.name,
          notify: true,
        };
        //-----------------------
        // write to delete array
        //-----------------------
        // console.log("marker needs to be deleted at = " + k);
        delete_marker_array.push(delete_parm);
      }
      //-------------------
      // set slot as blank
      //-------------------
      // console.log("setting blank at = " + k);
      setBlankCA(slot_parm);
    }
  }
  return delete_marker_array;
}
